"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteViewSnapshotsForTenant = exports.siteViewEditorListForTenant = exports.siteViewConfigForTenant = exports.siteUpdateForTenant = exports.siteUnrestrictForTenant = exports.siteSuccessForTenant = exports.siteSubmitForTenant = exports.siteSaveForTenant = exports.siteRestrictForTenant = exports.siteResetWithoutListForTenant = exports.siteResetForTenant = exports.siteReadForTenant = exports.sitePlayForTenant = exports.sitePauseForTenant = exports.siteListReviewAndApprovalForTenant = exports.siteListForTenant = exports.siteFilterForTenant = exports.siteErrorForTenant = exports.siteEditSaveResetForTenant = exports.siteEditSaveForTenant = exports.siteEditForTenant = exports.siteDownloadEmailForTenant = exports.siteDeleteForTenant = exports.siteCopyUrlForTenant = exports.siteCloneForTenant = exports.siteChangeResetForTenant = exports.siteChangeForTenant = exports.siteBuildListForTenant = exports.siteApproveForTenant = exports.siteAddForTenant = void 0;
var _siteForTenant = require("./siteForTenant.constant");
// @flow

// common success
var siteSuccessForTenant = function siteSuccessForTenant(actionType, data) {
  return {
    type: _siteForTenant.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.siteSuccessForTenant = siteSuccessForTenant;
var siteErrorForTenant = function siteErrorForTenant(actionType, error) {
  return {
    type: _siteForTenant.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteErrorForTenant = siteErrorForTenant;
var siteAddForTenant = function siteAddForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.ADD,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteAddForTenant = siteAddForTenant;
var siteEditSaveForTenant = function siteEditSaveForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.EDIT_SAVE,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteEditSaveForTenant = siteEditSaveForTenant;
var siteEditSaveResetForTenant = function siteEditSaveResetForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.EDIT_SAVE_RESET,
    payload: payload
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add site.
 */
exports.siteEditSaveResetForTenant = siteEditSaveResetForTenant;
var siteEditForTenant = function siteEditForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.EDIT,
    payload: payload
  };
};

/**
 * read site
 * @param payload
 * @returns api response
 * @description this function used to read site.
 */
exports.siteEditForTenant = siteEditForTenant;
var siteReadForTenant = function siteReadForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.READ,
    payload: payload
  };
};

/**
 * change site
 * @param payload
 * @returns api response
 * @description this function used to change site.
 */
exports.siteReadForTenant = siteReadForTenant;
var siteChangeForTenant = function siteChangeForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.CHANGE,
    payload: payload
  };
};

/**
 * change site
 * @param payload
 * @returns api response
 * @description this function used to change site.
 */
exports.siteChangeForTenant = siteChangeForTenant;
var siteChangeResetForTenant = function siteChangeResetForTenant() {
  return {
    type: _siteForTenant.actionTypes.RESET_CHANGE
  };
};

/**
 * update site
 * @param payload
 * @returns api response
 * @description this function used to update site.
 */
exports.siteChangeResetForTenant = siteChangeResetForTenant;
var siteUpdateForTenant = function siteUpdateForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.UPDATE,
    payload: payload
  };
};

/**
 * list of site
 * @param payload
 * @returns api response
 * @description this function used to list of site.
 */
exports.siteUpdateForTenant = siteUpdateForTenant;
var siteListForTenant = function siteListForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.LIST,
    payload: payload
  };
};

/**
 * list of site
 * @param payload
 * @returns api response
 * @description this function used to list of site.
 */
exports.siteListForTenant = siteListForTenant;
var siteListReviewAndApprovalForTenant = function siteListReviewAndApprovalForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.LIST_REVIEW_APPROVAL,
    payload: payload
  };
};

/**
 * submit site
 * @param payload
 * @returns api response
 * @description this function used to submit site.
 */
exports.siteListReviewAndApprovalForTenant = siteListReviewAndApprovalForTenant;
var siteSubmitForTenant = function siteSubmitForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.SUBMIT,
    payload: payload
  };
};

/**
 * approve site
 * @param payload
 * @returns api response
 * @description this function used to approve site.
 */
exports.siteSubmitForTenant = siteSubmitForTenant;
var siteApproveForTenant = function siteApproveForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.APPROVE,
    payload: payload
  };
};

/**
 * delete site
 * @param payload
 * @returns api response
 * @description this function used to delete site.
 */
exports.siteApproveForTenant = siteApproveForTenant;
var siteDeleteForTenant = function siteDeleteForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.DELETE,
    payload: payload
  };
};

/**
 * clone site
 * @param payload
 * @returns api response
 * @description this function used to clone site.
 */
exports.siteDeleteForTenant = siteDeleteForTenant;
var siteCloneForTenant = function siteCloneForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.CLONE,
    payload: payload
  };
};

/**
 * save site
 * @param payload
 * @returns api response
 * @description this function used to save site.
 */
exports.siteCloneForTenant = siteCloneForTenant;
var siteSaveForTenant = function siteSaveForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.SAVE,
    payload: payload
  };
};

/**
 * build list site
 * @param payload
 * @returns api response
 * @description this function used to build list site.
 */
exports.siteSaveForTenant = siteSaveForTenant;
var siteBuildListForTenant = function siteBuildListForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.BUILD_LIST,
    payload: payload
  };
};

/**
 * filter of site
 * @param payload
 * @returns api response
 * @description this function used to filter of site.
 */
exports.siteBuildListForTenant = siteBuildListForTenant;
var siteFilterForTenant = function siteFilterForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.FILTER,
    payload: payload
  };
};

/**
 * pause site
 * @param payload
 * @returns api response
 * @description this function used to pause site.
 */
exports.siteFilterForTenant = siteFilterForTenant;
var sitePauseForTenant = function sitePauseForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.PAUSE,
    payload: payload
  };
};

/**
 * play site
 * @param payload
 * @returns api response
 * @description this function used to play site.
 */
exports.sitePauseForTenant = sitePauseForTenant;
var sitePlayForTenant = function sitePlayForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.PLAY,
    payload: payload
  };
};

/**
 * copy url of site
 * @param payload
 * @returns api response
 * @description this function used to copy url of site.
 */
exports.sitePlayForTenant = sitePlayForTenant;
var siteCopyUrlForTenant = function siteCopyUrlForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.COPY_URL,
    payload: payload
  };
};

/**
 * email
 * @param payload
 * @returns api response
 * @description this function used to email.
 */
exports.siteCopyUrlForTenant = siteCopyUrlForTenant;
var siteDownloadEmailForTenant = function siteDownloadEmailForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.DOWNLOAD_EMAIL,
    payload: payload
  };
};

/**
 * restrict site
 * @param payload
 * @returns api response
 * @description this function used to restrict site.
 */
exports.siteDownloadEmailForTenant = siteDownloadEmailForTenant;
var siteRestrictForTenant = function siteRestrictForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.RESTRICT,
    payload: payload
  };
};

/**
 * unrestrict site
 * @param payload
 * @returns api response
 * @description this function used to unrestrict site.
 */
exports.siteRestrictForTenant = siteRestrictForTenant;
var siteUnrestrictForTenant = function siteUnrestrictForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.UNRESTRICT,
    payload: payload
  };
};

/**
 * view snapshots
 * @param payload
 * @returns api response
 * @description this function used to view snapshots.
 */
exports.siteUnrestrictForTenant = siteUnrestrictForTenant;
var siteViewSnapshotsForTenant = function siteViewSnapshotsForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.VIEW_SNAPSHOTS,
    payload: payload
  };
};

/**
 * view editos of site
 * @param payload
 * @returns api response
 * @description this function used to view editos of site.
 */
exports.siteViewSnapshotsForTenant = siteViewSnapshotsForTenant;
var siteViewEditorListForTenant = function siteViewEditorListForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.VIEW_EDITOR_LIST,
    payload: payload
  };
};

/**
 * view config of site
 * @param payload
 * @returns api response
 * @description this function used to view config of site.
 */
exports.siteViewEditorListForTenant = siteViewEditorListForTenant;
var siteViewConfigForTenant = function siteViewConfigForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.VIEW_CONFIG,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.siteViewConfigForTenant = siteViewConfigForTenant;
var siteResetForTenant = function siteResetForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.RESET,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.siteResetForTenant = siteResetForTenant;
var siteResetWithoutListForTenant = function siteResetWithoutListForTenant(payload) {
  return {
    type: _siteForTenant.actionTypes.RESET_WITHOUT_LIST,
    payload: payload
  };
};
exports.siteResetWithoutListForTenant = siteResetWithoutListForTenant;